// Section2.jsx
import React from "react";
import blogsJson from "../../data/blogs.json";
import BlogCard from "../../componets/BlogCard"; // ✅ import

export default function Section2() {
  return (
    <div className="w-full Section2 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 section2-container relative w-full md:w-[750px] lg:w-[970px] xl:w-[100%] md:px-[15px] mx-auto">
        <h1 className="text-center text-[24px] md:text-[34px] font-bold text-[#DA2128] leading-10">
          Mean3 Blogs
        </h1>
        <div className="flex flex-wrap w-full justify-center xl:justify-start items-center py-[35px]">
          {blogsJson.map((item, index) => (
            <BlogCard key={item.imgUrl + index} blog={item} />
          ))}
        </div>
      </div>
    </div>
  );
}
